"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABAS_NOTAS_COMPRA = exports.ALERTAS_ITEM_CONFERENCIA = exports.SITUACOES_NOTA_COMPRA = void 0;
exports.SITUACOES_NOTA_COMPRA = ['A_CONFERIR', 'RECEBIDA', 'DEVOLVIDA_PARCIAL', 'DEVOLVIDA'];
exports.ALERTAS_ITEM_CONFERENCIA = [
    'SEM_VINCULO',
    'SEM_FATOR',
    'UNIDADE_DIVERGENTE',
    'FORA_PEDIDO',
    'EXCEDENTE',
];
exports.ABAS_NOTAS_COMPRA = ['TODAS', 'SEM_PEDIDO'];
//# sourceMappingURL=compras-nota.js.map